export default __webpack_public_path__ + "static/media/detail_small_5_5.ce6b9993.png";